
import { ParallaxEffectType } from '@/types';

export enum ParallaxCategory {
    ALL = 'ALL',
    CORE = 'CORE',
    NATURE = 'NATURE',
    COSMIC = 'COSMIC',
    CYBER = 'CYBER',
    ABSTRACT = 'ABSTRACT',
    ARTISTIC = 'ARTISTIC',
    MEDIA = 'MEDIA'
}

export const EFFECT_CATEGORIES: Record<ParallaxEffectType, ParallaxCategory> = {
    [ParallaxEffectType.STARRY_NIGHT]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.NEBULA_DRIFT]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.GRID_WORLD]: ParallaxCategory.CORE,
    [ParallaxEffectType.FLOATING_SHAPES]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.DATA_STREAM]: ParallaxCategory.CYBER,
    [ParallaxEffectType.GEOMETRIC_ABSTRACTION]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.VORTEX_TUNNEL]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.PARTICLE_FIELD]: ParallaxCategory.CORE,
    [ParallaxEffectType.AURORA_WAVES]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.CIRCUIT_BOARD]: ParallaxCategory.CYBER,
    [ParallaxEffectType.RETRO_GRID]: ParallaxCategory.CYBER,
    [ParallaxEffectType.MATRIX_RAIN]: ParallaxCategory.CYBER,
    [ParallaxEffectType.FRACTAL_CLOUDS]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.CYBER_PUNK_CITY]: ParallaxCategory.CYBER,
    [ParallaxEffectType.OCEAN_WAVES]: ParallaxCategory.NATURE,
    [ParallaxEffectType.DNA_HELIX]: ParallaxCategory.CYBER,
    [ParallaxEffectType.WATERMARK]: ParallaxCategory.CORE,
    [ParallaxEffectType.CONSTELLATIONS]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.DIGITAL_RAIN]: ParallaxCategory.CYBER,
    [ParallaxEffectType.NEON_LINES]: ParallaxCategory.CYBER,
    [ParallaxEffectType.BUBBLE_FIELD]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.HEXAGON_GRID]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.SPIRAL_GALAXY]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.ABSTRACT_WAVES]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.TECH_PIXELS]: ParallaxCategory.CYBER,

    // Nature
    [ParallaxEffectType.LAVA_FLOW]: ParallaxCategory.NATURE,
    [ParallaxEffectType.MOSS_GROWTH]: ParallaxCategory.NATURE,
    [ParallaxEffectType.CLOUD_FORMATIONS]: ParallaxCategory.NATURE,
    [ParallaxEffectType.ROOT_SYSTEMS]: ParallaxCategory.NATURE,
    [ParallaxEffectType.RIPPLE_POOLS]: ParallaxCategory.NATURE,
    [ParallaxEffectType.RAIN_STREAKS]: ParallaxCategory.NATURE,
    [ParallaxEffectType.FALLING_LEAVES]: ParallaxCategory.NATURE,
    [ParallaxEffectType.SNOW_FLURRY]: ParallaxCategory.NATURE,
    [ParallaxEffectType.SWAYING_GRASS]: ParallaxCategory.NATURE,
    [ParallaxEffectType.SAND_DUNES]: ParallaxCategory.NATURE,
    [ParallaxEffectType.CORAL_REEF]: ParallaxCategory.NATURE,
    [ParallaxEffectType.BAMBOO_FOREST]: ParallaxCategory.NATURE,
    [ParallaxEffectType.THUNDER_STORM]: ParallaxCategory.NATURE,
    [ParallaxEffectType.FIRE_EMBERS]: ParallaxCategory.NATURE,
    [ParallaxEffectType.JUNGLE_VINES]: ParallaxCategory.NATURE,
    [ParallaxEffectType.CHERRY_BLOSSOM]: ParallaxCategory.NATURE,
    [ParallaxEffectType.ICE_CRYSTALS]: ParallaxCategory.NATURE,
    [ParallaxEffectType.RIVER_CURRENT]: ParallaxCategory.NATURE,
    [ParallaxEffectType.VOLCANIC_ASH]: ParallaxCategory.NATURE,
    [ParallaxEffectType.MIST_DRIFT]: ParallaxCategory.NATURE,
    [ParallaxEffectType.BIO_LUMINESCENCE]: ParallaxCategory.NATURE,
    [ParallaxEffectType.PETAL_STORM]: ParallaxCategory.NATURE,
    [ParallaxEffectType.SUN_BEAMS]: ParallaxCategory.NATURE,
    [ParallaxEffectType.UNDERWATER_LIGHT]: ParallaxCategory.NATURE,
    [ParallaxEffectType.SPORE_DRIFT]: ParallaxCategory.NATURE,
    [ParallaxEffectType.WIND_WHIRLS]: ParallaxCategory.NATURE,

    // Abstract
    [ParallaxEffectType.VORONOI_CELLS]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.MOIRE_PATTERNS]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.LISSAJOUS_CURVES]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.FLOWER_OF_LIFE]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.KALEIDOSCOPE_MIRROR]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.FRACTAL_MANDALAS]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.SACRED_GEOMETRY]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.METATRON_CUBE]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.MANDELBROT_SET]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.JULIA_SET]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.PENROSE_TILING]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.SIERPINSKI_TRIANGLE]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.KOCH_SNOWFLAKE]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.HARMONIC_WAVES]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.ISOMETRIC_CUBES]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.DOT_MATRIX]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.WIREFRAME_TERRAIN]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.POLYGON_SPIRALS]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.TESSELLATED_HEXAGONS]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.MINIMALIST_LINES]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.BRUTALIST_BLOCKS]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.OP_ART_ILLUSION]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.SYMMETRIC_ORBS]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.HYPNOTIC_SPIRALS]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.TRIANGULAR_SUBDIVISION]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.CRYSTALLINE_LATTICE]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.FLUID_SUBSTANCE]: ParallaxCategory.ABSTRACT,
    [ParallaxEffectType.VECTOR_FIELD]: ParallaxCategory.ABSTRACT,

    // Cyber
    [ParallaxEffectType.HUD_OVERLAY]: ParallaxCategory.CYBER,
    [ParallaxEffectType.TERMINAL_STREAMS]: ParallaxCategory.CYBER,
    [ParallaxEffectType.DATA_NODES]: ParallaxCategory.CYBER,
    [ParallaxEffectType.RADAR_SWEEP]: ParallaxCategory.CYBER,
    [ParallaxEffectType.SCHEMATIC_GRID]: ParallaxCategory.CYBER,
    [ParallaxEffectType.GLITCH_PIXELS]: ParallaxCategory.CYBER,
    [ParallaxEffectType.SCANLINE_PROCESSOR]: ParallaxCategory.CYBER,
    [ParallaxEffectType.BINARY_CASCADE]: ParallaxCategory.CYBER,
    [ParallaxEffectType.CIRCUIT_FLOW]: ParallaxCategory.CYBER,
    [ParallaxEffectType.NEURAL_NETWORK]: ParallaxCategory.CYBER,
    [ParallaxEffectType.FIRMWARE_DIAGRAM]: ParallaxCategory.CYBER,
    [ParallaxEffectType.TARGETING_RETICLES]: ParallaxCategory.CYBER,
    [ParallaxEffectType.SATELLITE_LINK]: ParallaxCategory.CYBER,
    [ParallaxEffectType.SECURITY_MESH]: ParallaxCategory.CYBER,
    [ParallaxEffectType.ENCRYPTION_MATRIX]: ParallaxCategory.CYBER,
    [ParallaxEffectType.TECH_SPECS]: ParallaxCategory.CYBER,
    [ParallaxEffectType.ANALOG_NOISE]: ParallaxCategory.CYBER,
    [ParallaxEffectType.VIRTUAL_REALITY]: ParallaxCategory.CYBER,
    [ParallaxEffectType.CYBER_SPACE]: ParallaxCategory.CYBER,
    [ParallaxEffectType.DIGITAL_SIGNAL]: ParallaxCategory.CYBER,
    [ParallaxEffectType.PULSE_WAVE]: ParallaxCategory.CYBER,
    [ParallaxEffectType.SIGNAL_INTERFERENCE]: ParallaxCategory.CYBER,
    [ParallaxEffectType.BIO_HAZARD]: ParallaxCategory.CYBER,
    [ParallaxEffectType.RADIATION_SCAN]: ParallaxCategory.CYBER,
    [ParallaxEffectType.SONAR_PING]: ParallaxCategory.CYBER,
    [ParallaxEffectType.COORDINATE_SYSTEM]: ParallaxCategory.CYBER,
    [ParallaxEffectType.DEBUG_CONSOLE]: ParallaxCategory.CYBER,
    [ParallaxEffectType.SYSTEM_MAINFRAME]: ParallaxCategory.CYBER,

    // Cosmic
    [ParallaxEffectType.SUPERNOVA]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.EVENT_HORIZON]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.DARK_MATTER]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.STAR_CLUSTERS]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.WORMHOLE]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.COSMIC_BACKGROUND]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.QUANTUM_FOAM]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.SOLAR_FLARE]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.PULSAR_BEAM]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.NEBULA_GLOW]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.BLACK_HOLE_SINGULARITY]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.QUASAR_JET]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.GALACTIC_CORE]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.STELLAR_NURSERY]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.COMET_TAIL]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.METEOR_SHOWER]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.ATMOSPHERIC_ENTRY]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.DIMENSIONAL_RIFT]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.STRINGS_THEORY]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.MULTIVERSE_BUBBLES]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.ENTROPY_HEAT_DEATH]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.GRAVITY_WAVES]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.SPACE_TIME_DISTORTION]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.AURORA_BOREALIS]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.ANTI_MATTER]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.VOID_VOID]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.CELESTIAL_BODY]: ParallaxCategory.COSMIC,
    [ParallaxEffectType.EXPANDING_UNIVERSE]: ParallaxCategory.COSMIC,

    // Artistic
    [ParallaxEffectType.OIL_PAINTING]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.SKETCH_BOOK]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.STAINED_GLASS]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.MOSAIC_TILES]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.CARBON_FIBER]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.BRUSHED_METAL]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.LIQUID_METAL]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.INK_BLEED]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.WATERCOLOR]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.POP_ART]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.COMIC_DOTS]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.OLD_FILM]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.VHS_GLITCH]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.PRISM_LIGHT]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.CHALK_DRAWING]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.PIXEL_ART_LANDSCAPE]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.SYNTHWAVE_GRID]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.VAPOR_WAVE]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.CHARCOAL_SKETCH]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.CROSS_HATCH]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.WOOD_GRAIN]: ParallaxCategory.ARTISTIC,
    [ParallaxEffectType.MARBLE_TEXTURE]: ParallaxCategory.ARTISTIC,

    // Media
    [ParallaxEffectType.IMAGE_OVERLAY]: ParallaxCategory.MEDIA,
    [ParallaxEffectType.SCROLLING_IMAGE]: ParallaxCategory.MEDIA,
    [ParallaxEffectType.VIDEO_BACKDROP]: ParallaxCategory.MEDIA,
    [ParallaxEffectType.VIDEO_TEXTURE]: ParallaxCategory.MEDIA,
    [ParallaxEffectType.MEDIA_MOSAIC]: ParallaxCategory.MEDIA,

    [ParallaxEffectType.NONE]: ParallaxCategory.CORE
};
